import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { checkIOSMobileDevice } from "../../../utils/global";
import parseEmoji from "../../../utils/parseEmoji";
import { isBotxoDomain } from "../../../utils/rebranding";

import myStyles from "./plain-input.cssmodule.scss";

const isPrevDomain = isBotxoDomain();

const PlainInput = ({
  value,
  onChange,
  onEnter,
  readOnly,
  fontSize,
  isFocus,
  altText,
  customPlaceholder,
  inputScriptType,
  disabled,
}) => {
  const editorRef = React.createRef();
  const [valueInput, setValueInput] = useState(value);

  useEffect(() => {
    setValueInput(value);
  }, [value]);

  useEffect(() => {
    editorRef.current.focus();
  }, [isFocus]);

  const onChangeHandler = e => {
    setValueInput(parseEmoji(e.target.value));
  };

  const onBlur = () => {
    onChange(valueInput);
  };

  const getInputStyleFontSize = () => {
    const defaultFontSize = `${fontSize}px`;
    if (checkIOSMobileDevice()) {
      return fontSize < "16" ? "16px" : defaultFontSize;
    }
    return defaultFontSize;
  };

  const inputStyle = isPrevDomain
    ? {}
    : {
        backgroundColor: "transparent",
      };

  return (
    <form
      onSubmit={e => {
        if (!disabled) {
          onEnter(valueInput);
          setValueInput("");
        }
        e.preventDefault();
      }}
    >
      <input
        ref={editorRef}
        className={cx(myStyles.input, {
          [myStyles.inputBottom]: inputScriptType === "bottom",
          disabled,
        })}
        type="text"
        value={valueInput}
        onChange={onChangeHandler}
        onBlur={onBlur}
        readOnly={readOnly}
        placeholder={customPlaceholder}
        style={{
          fontSize: getInputStyleFontSize(),
          ...inputStyle,
        }}
        title={altText}
        aria-label={altText}
        disabled={disabled}
      />
    </form>
  );
};

PlainInput.propTypes = {
  value: PropTypes.string,
  onEnter: PropTypes.func,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  fontSize: PropTypes.string,
  isFocus: PropTypes.bool,
  altText: PropTypes.string,
  customPlaceholder: PropTypes.string,
  inputScriptType: PropTypes.string,
  disabled: PropTypes.bool,
};

PlainInput.defaultProps = {
  value: "",
  onChange: () => null,
  onEnter: () => null,
  readOnly: false,
};

export default PlainInput;
